import { useId } from 'react'
import { TIMES_OF_DAY, type TimeOfDay } from '../../lib/time-of-day'
import { useLocale } from '../use-locale'

const HOURS: Record<TimeOfDay, string> = { morning: '7:00', day: '13:00', evening: '17:30', night: '22:00' }

/** 店の時間帯を切り替える。背景の店がその場で朝・昼・夕・夜に変わる */
export function TimeDial({ value, onChange }: { value: TimeOfDay; onChange: (t: TimeOfDay) => void }) {
  const { t } = useLocale()
  const name = useId()
  return (
    <fieldset className="dial" style={{ ['--k' as string]: TIMES_OF_DAY.indexOf(value) }}>
      <legend className="sr-only">{t.lp.timePick}</legend>
      <span className="dial__track" aria-hidden="true">
        <span className="dial__thumb" />
      </span>
      {TIMES_OF_DAY.map((k) => (
        <label key={k} className={`dial__opt${value === k ? ' is-on' : ''}`}>
          <input type="radio" name={name} value={k} checked={value === k} onChange={() => onChange(k)} />
          <span className="dial__hour">{HOURS[k]}</span>
          <span className="dial__label">{t.lp.times[k]}</span>
        </label>
      ))}
    </fieldset>
  )
}
